/**
 * Format call duration from seconds to human-readable format
 * @param seconds - Duration in seconds
 * @returns Formatted string like "45m 30s" or "30s"
 */
export function formatCallDuration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined || isNaN(Number(seconds))) {
    return "0s";
  }

  const totalSeconds = Math.floor(Number(seconds));
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;

  if (minutes > 0) {
    return `${minutes}m ${remainingSeconds}s`;
  }
  return `${remainingSeconds}s`;
}
